/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */
import { StrictMode, startTransition } from 'react'

import { RemixBrowser } from '@remix-run/react'
import { hydrateRoot } from 'react-dom/client'
import { initFirebase } from '~/firebase.config.client'
import { setupI18n } from './i18n.client'
import { setupLogrocket } from './logrocket.client'

setupI18n()
setupLogrocket()

if (typeof document !== 'undefined') {
    initFirebase()
}

startTransition(() => {
    hydrateRoot(
        document,
        <StrictMode>
            <RemixBrowser />
        </StrictMode>,
    )
})
